import { app } from '../../app';

app.component('spGroupLink', {
    bindings: {
        groupId: '<',
        groupName: '<',
        groupType: '<',
        hideIcon: '<',
        tooltipPlacement: '@',
    },
    templateUrl: require('./sp-group-link.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-group-link/sp-group-link.component.js